<template>
  <div class="searcher">
    <el-row :gutter="10" class="row-filters-bar">
      <!-- Columna principal con los diferentes filtros disponibles -->
      <div class="main-container-filtersbar">
        <locationSelector />
        <div class="container-data-selector el-button btn-primary-brains btn-input-type-brains el-button--default el-button--small el-popover__reference">
          <geographicalLevelSelector :titulo-visible="true" />
        </div>
        <div v-if="activeNav !== 'reports'" class="container-data-selector el-button btn-primary-brains btn-input-type-brains el-button--default el-button--small el-popover__reference">
          <mapDataSelector />
        </div>
        <div v-if="activeNav !== 'reports'" class="divinvfilter">
          <popoverBtn>
            <template v-slot:popoverName>{{ $t('investmentFilter') }}</template>
            <investmentFilter />
          </popoverBtn>
        </div>
        <div v-if="isvaluations">
          <popoverBtn>
            <template v-slot:popoverName>{{ $t('valuationFilter') }}</template>
            <valuationFilter />
          </popoverBtn>
        </div>
        <div v-if="isportfolio">
          <portfolioBar />
        </div>
        <div v-if="activeNav === 'reports'">
          <reportFilter />
        </div>
      </div>
    </el-row>
  </div>
</template>
<script>
import locationSelector from '@/components/LocationSelector.vue'
import mapDataSelector from '@/components/MapDataSelector.vue'
import investmentFilter from '@/components/InvestmentFilter.vue'
import geographicalLevelSelector from '@/components/geographicalLevelSelector.vue'
import popoverBtn from '@/components/designComponents/popoverBtn'
import valuationFilter from '@/components/ValuationFilter.vue'
import portfolioBar from '@/components/PortfolioBar.vue'
import reportFilter from '@/components/reportFilter.vue'
import { mapState } from 'vuex'
export default {
  name: 'ExploreFilters',
  components: { locationSelector, mapDataSelector, investmentFilter, popoverBtn, geographicalLevelSelector, valuationFilter, portfolioBar, reportFilter },
  computed: {
    ...mapState('user', {
      activeNav: (state) => state.activeNav
    }),
    isvaluations: function() {
      return this.activeNav === 'valuation'
    },
    isportfolio: function() {
      return this.activeNav === 'portfolio'
    }
  }
}
</script>

<style scoped>
.divinvfilter {
  margin-right: 10px;
}
</style>

